import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { registerDatasourcesV2 } from '../redux/datasourceSlice.js';
import { fetchDashboardDatasources } from './api.js';
import { datasourceKey } from './constants.js';

// Puts the dashboard's v2 datasources into the datasources store, so the existing datasource
// pickers of filter widgets (button, advanced and project filters) can target them. Editors only.
export default function useRegisterDatasourcesV2(enabled) {
  const dispatch = useDispatch();
  const dashboardId = useSelector((state) => state.dashboard.dashboardId);

  const { data } = useQuery({
    queryKey: ['datasource_v2_dashboard_datasources', dashboardId],
    queryFn: () => fetchDashboardDatasources(dashboardId),
    enabled: !!enabled && dashboardId != null,
  });

  useEffect(() => {
    if (!data) return;
    dispatch(registerDatasourcesV2(data.in_dashboard.map((d) => ({
      key: datasourceKey(d.id),
      name: I18n.t('datasource_v2_label', { name: d.name }),
      cols: d.cols,
    }))));
  }, [data, dispatch]);
}
